module.exports = __webpack_public_path__ + "img/ex-post.8cb9dd1d.jpg";